/**
 * The `/badge` command read on the page (ADR-112 decision 5.5, amended 2026-10-16, P1.9-T203): `/badge` asks what is worn,
 * `/badge hide` and `/badge off` hide the badge, `/badge show` and `/badge on` show it. There is no choice of a type: the
 * badge is the one the roles give, so a word that names a type is the usage. The page holds what is typed to these words
 * and sends nothing for the rest.
 */

/**
 * What the command asks for: what is worn, to hide, to show, or, for a command out of its syntax, its usage.
 */
export type BadgeAsk = { readonly kind: "status" } | { readonly kind: "hide" } | { readonly kind: "show" } | { readonly kind: "usage" };

/**
 * The command's word, `/badge`, without the slash, in lower case.
 */
export const BADGE_COMMAND_WORD = "badge";

/**
 * The words that switch the badge, in the order the usage lists them: `hide` and `show`, and `off` and `on` for the same two.
 */
export const BADGE_SWITCH_WORDS: readonly string[] = ["hide", "show", "off", "on"];

/**
 * Reads what follows `/badge`.
 *
 * @param rest The text after the command's word, as typed.
 * @returns What it asks for.
 * @example
 * readBadgeCommand("off");
 * // { kind: "hide" }
 */
export function readBadgeCommand(rest: string): BadgeAsk {
  const typed = rest.trim().toLowerCase();
  if (typed === "") {
    return { kind: "status" };
  }
  if (typed === "hide" || typed === "off") {
    return { kind: "hide" };
  }
  if (typed === "show" || typed === "on") {
    return { kind: "show" };
  }
  return { kind: "usage" };
}
